import { render, staticRenderFns } from "./health-symtoms.input.vue?vue&type=template&id=3b7a6a1d&"
import script from "./health-symtoms.input.vue?vue&type=script&lang=ts&"
export * from "./health-symtoms.input.vue?vue&type=script&lang=ts&"
import style0 from "./health-symtoms.input.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports